import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  Output,
  EventEmitter
} from "@angular/core";
import {
  VideoCallManager,
  VideoCallLifeCycles
} from "@app/tokbox/services/video-call-manager.service";
import { VideoCallStateManagerService } from "@app/tokbox/services/video-call-state-manager.service";
import { LoadingComponent } from "@app/tokbox/components/loading/loading.component";
import { ModalDirective } from "ngx-bootstrap";
import swal from "sweetalert2";
import { AppointmentService } from "@app/shared/services/appointment.service";
import { MixpanelEventLoggingService } from "@app/shared/services/mixpanel-event-logging.service";

@Component({
  selector: "video-call-widget",
  templateUrl: "video-call-widget.component.html",
  providers: [VideoCallManager, VideoCallStateManagerService],
  viewProviders: [LoadingComponent],
  styleUrls: ["./video-call-widget.component.css"],
  exportAs: "SecheduleCallModal"
})
export class VideoCallWidgetComponent
  implements OnInit, VideoCallLifeCycles, OnDestroy {
  @ViewChild("SecheduleCallModal")
  public SecheduleCallModal: ModalDirective;
  @Output()
  refreshAPI: EventEmitter<any> = new EventEmitter();
  isCallEstablished: boolean = false;
  isCallAnswered: boolean = false;

  hasIncomingCall: boolean = false;
  isIncomingCallAnswered: boolean = false;

  isVideoOn: boolean;

  screenshotOfTheOtherUser: string;
  msgFromBuddy: string;
  msgForBuddy: string;

  publisherProperties = {
    insertMode: "append",
    width: "100%",
    height: "100%",
    usePreviousDeviceSelection: true
  };

  subscriberProperties = {
    insertMode: "append",
    width: "100%",
    height: "100%"
  };

  publisherTag: string = "publisher";
  subscriberTag: string = "subscriber";
  appointmentId: string = "";

  @Input()
  sessionId: string;
  @Input()
  token: string;
  analystName;
  userDetailsObject: any;

  constructor(
    private videoCallManager: VideoCallManager,
    private appointmentService: AppointmentService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
  ) {}

  ngOnInit(): void {}

  private _initIncomingCallRequirements() {
    this.videoCallManager
      .initIncomingCallRequirements(
        this.sessionId,
        this.token,
        this.publisherTag,
        this.publisherProperties,
        this.subscriberTag,
        this.subscriberProperties
      )
      .subscribe();
  }

  call() {
    if (!this.isCallEstablished) {
      this.isCallEstablished = true;
      this.videoCallManager
        .call(this.publisherTag, this.publisherProperties)
        .subscribe(() => {
          //console.log("CALLING")
          this.isIncomingCallAnswered = false;
          this.hasIncomingCall = false;
          this.isVideoOn = true;
        });
    }
  }
  showModal(appointmentId, name?: string) {
    this.userDetails();
    if (name && this.userDetailsObject.roles[0].code !== 'tech_analyst') {
      this.analystName = name;
    } else if (this.userDetailsObject.roles[0].code === 'tech_analyst'){
      this.analystName = this.userDetailsObject.firstName + " " +this.userDetailsObject.lastName;
    }
    this.appointmentId = appointmentId;
    this.videoCallManager.getTokboxDetails(appointmentId).subscribe(
      (response: any) => {
        this.sessionId = response.sessionId;
        this.token = response.token;
        this.videoCallManager.addVideoCallLifeCyclesListener(this);
        this._initIncomingCallRequirements();
        this.SecheduleCallModal.show();
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    );
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
    }
  }

  hideModal() {
    this.SecheduleCallModal.hide();
  }

  hangUp() {
    this.mixpanelEventLoggingService.dispatchEvent("disconnect call", {
      "Tech Analyst": this.analystName ? this.analystName : ''
    });
    this.videoCallManager.hangUp();
    this.diconnectCall();
    this.hideVideosSection();
    this.hideModal();
  }

  hideVideosSection() {
    this.isCallAnswered = false;
    this.isCallEstablished = false;
    this.isIncomingCallAnswered = false;
    this.hasIncomingCall = false;
  }

  answerCall() {
    this.videoCallManager
      .call(this.publisherTag, this.publisherProperties)
      .subscribe(() => {
        this.isVideoOn = true;
        //console.log("onIncomingCallAnswered")
        this.hasIncomingCall = false;
        this.isIncomingCallAnswered = true;
      });
  }
  diconnectCall() {
    this.appointmentService
      .diconnectAppointment(this.appointmentId)
      .subscribe(rep => {
      }, error => {
      });
  }

  takeScreenshot() {
    this.screenshotOfTheOtherUser = this.videoCallManager.getSubscriberScreenshot();
  }

  removeVideo() {
    this.videoCallManager.showVideo(false);
    this.isVideoOn = false;
  }

  showVideo() {
    this.videoCallManager.showVideo(true);
    this.isVideoOn = true;
  }

  sendSignalToBuddy() {
    this.videoCallManager.sendSignal(this.msgForBuddy);
  }

  clearMsg() {
    this.msgFromBuddy = null;
  }

  onIncomingCall(): void {
    if (this.isCallEstablished) {
      //console.log("onCallStarted")
      this.isCallAnswered = true;
    } else {
      //console.log("onIncomingCall")
      this.hasIncomingCall = true;
    }
  }

  onMediaAccessRequest(): void {
    //console.log("MEDIA ACCESS REQUEST")
  }

  onMediaAccessDenied(): void {
    //console.log("MEDIA ACCESS DENIED")
  }

  onCallHungUpByOther(): void {
    //console.log("onCallHungUpByOther")
    this.hangUp();
  }

  onCallHungUp(): void {
    //console.log("onCallHungUp")
  }

  onNetworkLost(): void {
    //console.log("Network Lost")
  }

  onMissedCall(): void {
    //console.log("Missed Call")
  }

  onMessageReceived(msg: string) {
    this.msgFromBuddy = msg;
  }

  onVideoChanged() {
    //console.log("onVideoChanged")
  }

  ngOnDestroy() {
    this.videoCallManager.removeVideoCallLifeCyclesListener(this);
  }
}



// WEBPACK FOOTER //
// ./src/app/tokbox/components/video-call-widget/video-call-widget.component.ts